import axios from "axios";
import showdown from "showdown";
import { STRAPI_DEV_URL, STRAPI_PROD_URL } from "./strapiContent.constants";

export const getStrapiContent = async(path) => {
    const enviroment =
        process.env.VUE_APP_ENV === "development" ?
        STRAPI_DEV_URL :
        STRAPI_PROD_URL;
    return await axios.get(enviroment + path);
};

export const formatMarkdownToHtml = (value) => {
    const convertor = new showdown.Converter();
    return convertor.makeHtml(value);
};